<template>
  <div class="uk-padding-small h-100 border-box uk-container">
    <v-search
      :formContent="formContent"
      :SearchForm="SearchForm"
      :inline="true"
      @resetFn="resetFn"
      @searchFn="getList"
      @confirmFn="getList"
    >
      <!--      <template v-slot:bottom>-->
      <!--        <div class="uk-flex uk-flex-middle">-->
      <!--          <div class="check">-->
      <!--            <el-checkbox-->
      <!--              border-->
      <!--              :indeterminate="indeterminate"-->
      <!--              v-model="checked"-->
      <!--              @change="change"-->
      <!--            >-->
      <!--            </el-checkbox>-->
      <!--          </div>-->
      <!--          <v-button-->
      <!--            @DelFn="DelFn"-->
      <!--            :optareBtn="optareBtn"-->
      <!--            v-bind="$attrs"-->
      <!--            v-on="$listeners"-->
      <!--          ></v-button>-->
      <!--        </div>-->
      <!--      </template>-->

      <!--      <IconDesc class="question" :icon-desc="iconDesc"></IconDesc>-->
    </v-search>

    <el-table
      :data="tableData"
      tooltip-effect="dark"
      stripe
      :header-cell-style="headCellStyle"
      height="calc(100% - 100px)"
      @cuechange="pageChange"
      :row-style="{ height: '50px' }"
    >
      <!--      <el-table-column type="selection" width="55" />-->
      <el-table-column :label="$t('客户')" prop="sceneName"></el-table-column>
      <el-table-column :label="$t('名称')" prop="name"></el-table-column>
      <el-table-column :label="$t('操作')">
        <template #default="{ row }">
          <div class="uk-flex uk-flex-center">
            <el-button
              type="text"
              icon="el-icon-download"
              :title="$t('integration.download')"
              @click="download(row)"
            ></el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <Pager :total="total" :size="SearchForm.iDisplayLength"></Pager>
  </div>
</template>

<script>
import { formContent } from '@/pages/win/DataBackup/schema/search'
import {
  downloadBackupFile,
  getBackupFileData,
  getBackupScene
} from '@/api/modules/public'

import Pager from '@/components/Pagination/src/Pager.vue'

export default {
  components: { Pager },
  computed: {
    formContent () {
      return formContent
    }
  },
  data () {
    return {
      tableData: [],
      total: 0,
      SearchForm: {
        iDisplayStart: 0,
        iDisplayLength: 15,
        sceneId: null,
        from: null,
        to: null
      },
      optareBtn: [
        // {
        //   id: 1,
        //   icon: '',
        //   vHas: ['delRange'],
        //   text: 'buttonTitle.Delete',
        //   method: 'DelFn'
        // }
      ]
    }
  },
  mounted () {
    getBackupScene().then(({ result }) => {
      if (!result.length) {
        return
      }

      // this.SearchForm.sceneId = result[0].sceneId

      formContent[0].selectParam = result.map(item => ({
        label: item.sceneName,
        value: item.sceneId
      }))
      this.getList()
    })
  },
  methods: {
    pageChange ({ iDisplayStart, iDisplayLength }) {
      this.SearchForm.iDisplayStart = iDisplayStart
      this.SearchForm.iDisplayLength = iDisplayLength
      this.getList()
    },
    getList () {
      console.log(this.SearchForm)
      if (this.SearchForm.time) {
        this.SearchForm.from = new Date(this.SearchForm.time[0]).getTime()
        this.SearchForm.to = new Date(this.SearchForm.time[1]).getTime()
      }
      getBackupFileData(this.SearchForm).then(({ result }) => {
        this.total = result.pageInfo.total
        this.tableData = result.result
      })
    },
    download (row) {
      downloadBackupFile(row.path).then(res => {
        console.log(res)
      })
    },
    resetFn () {
      this.SearchForm = {
        iDisplayStart: 0,
        iDisplayLength: 15,
        sceneId: null,
        from: null,
        to: null
      }
    }
  }
}
</script>
